module.exports = __webpack_public_path__ + "img/face-grin-tongue-wink.5fee1d09.svg";